import "Modernizr";
import "alpinejs";

let dLocale = new Date().toLocaleString("en-US", {
    timeZone: "America/New_York"
});

let d = new Date(dLocale);
let n = d.getDay();
let now = (d.getHours() + "." + d.getMinutes()) * 1;

let weekdays = [
    ["Sunday"],
    ["Monday", 8.0, 17.0],
    ["Tuesday", 8.0, 17.0],
    ["Wednesday", 8.0, 17.0],
    ["Thursday", 8.0, 17.0],
    ["Friday", 8.0, 16.0],
    ["Saturday"]


];

let day = weekdays[n];

if (now > day[1] && now < day[2]) {
    var hoursString = "Call Now - We're Open";
}
else {
    var hoursString = "Mon-Thurs 8-5, Fri 8-4";
}

document.querySelector(".time").innerHTML = hoursString;
document.querySelector(".nav-time").innerHTML = hoursString;
